function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M8.03264095,11.0587228 C9.77744807,11.0587228 11.0652819,9.92397875 11.0652819,8.01922977 C11.0652819,6.13474407 9.77744807,5 8.03264095,5 C6.30860534,5 5,6.13474407 5,8.01922977 C5,9.92397875 6.30860534,11.0587228 8.03264095,11.0587228 Z M8.71810089,19.3666705 L17.1305638,5.22289616 L15.2611276,5.22289616 L6.84866469,19.3666705 L8.71810089,19.3666705 Z M8.03264095,9.92397875 C7.11869436,9.92397875 6.51632047,9.27555357 6.51632047,8.01922977 C6.51632047,6.74264269 7.11869436,6.13474407 8.03264095,6.13474407 C8.94658754,6.13474407 9.56973294,6.74264269 9.56973294,8.01922977 C9.56973294,9.27555357 8.94658754,9.92397875 8.03264095,9.92397875 Z M15.9881306,19.60983 C17.7121662,19.60983 19,18.4548226 19,16.5703369 C19,14.6655879 17.7121662,13.5308438 15.9881306,13.5308438 C14.2433234,13.5308438 12.9554896,14.6655879 12.9554896,16.5703369 C12.9554896,18.4548226 14.2433234,19.60983 15.9881306,19.60983 Z M15.9673591,18.4345593 C15.0534125,18.4345593 14.4302671,17.8266607 14.4302671,16.5703369 C14.4302671,15.2937498 15.0534125,14.6858512 15.9673591,14.6858512 C16.8813056,14.6858512 17.504451,15.2937498 17.504451,16.5703369 C17.504451,17.8266607 16.8813056,18.4345593 15.9673591,18.4345593 Z"
}));
function SvgBezoekenPercentageSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBezoekenPercentageSelected);
export default __webpack_public_path__ + "static/media/BezoekenPercentage_selected.3e83f9b86d85812066af8a1f01abc34c.svg";
export { ForwardRef as ReactComponent };